module.exports = __webpack_public_path__ + "24e004ab/img/document.e2130c6b.svg";